import { Box, Checkbox, FormControl, InputLabel, ListItemText, MenuItem, Select, TextField } from '@mui/material';

const ProductListFilters = ({ filters, options, onChange }) => {
    const updateFilter = (key) => ({ target }) => {
        onChange({ ...filters, [key]: target.value });
    };

    const renderSelected = (values) => values.join(', ');

    return (
        <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: {
            xs: '1fr', sm: 'repeat(2, 1fr)', lg: 'repeat(5, 1fr)'
        }, mb: 4 }}>
            <FormControl size="small">
                <InputLabel id="product-brand-filter">Marca</InputLabel>
                <Select
                    labelId="product-brand-filter"
                    multiple
                    value={filters.brands}
                    label="Marca"
                    onChange={updateFilter('brands')}
                    renderValue={renderSelected}
                >
                    {options.brands.map(brand => <MenuItem key={brand} value={brand}>
                        <Checkbox checked={filters.brands.includes(brand)} />
                        <ListItemText primary={brand} />
                    </MenuItem>)}
                </Select>
            </FormControl>
            <FormControl size="small">
                <InputLabel id="product-category-filter">Categoría</InputLabel>
                <Select
                    labelId="product-category-filter"
                    multiple
                    value={filters.categories}
                    label="Categoría"
                    onChange={updateFilter('categories')}
                    renderValue={renderSelected}
                >
                    {options.categories.map(category => <MenuItem key={category} value={category}>
                        <Checkbox checked={filters.categories.includes(category)} />
                        <ListItemText primary={category} />
                    </MenuItem>)}
                </Select>
            </FormControl>
            <TextField size="small" label="Precio mínimo" type="number" inputProps={{ min: 0 }}
                value={filters.minPrice} onChange={updateFilter('minPrice')} />
            <TextField size="small" label="Precio máximo" type="number" inputProps={{ min: 0 }}
                value={filters.maxPrice} onChange={updateFilter('maxPrice')} />
            <FormControl size="small">
                <InputLabel id="product-inventory-filter">Inventario</InputLabel>
                <Select labelId="product-inventory-filter" value={filters.inventory}
                    label="Inventario" onChange={updateFilter('inventory')}>
                    <MenuItem value="all">Todos</MenuItem>
                    <MenuItem value="out">Sin existencias</MenuItem>
                    <MenuItem value="low">Bajo (1–5)</MenuItem>
                    <MenuItem value="available">Disponible</MenuItem>
                </Select>
            </FormControl>
        </Box>
    );
};

export default ProductListFilters;
